import React, {PureComponent} from 'react'
import cn from "classnames"
import injectSheet from 'react-jss'
import RichTextContainer from "../Widgets/RichTextContainer"
import CentredContentContainer from "../Widgets/CentredContentContainer"

class YouTubeContent extends PureComponent {

    render() {
        const {classes, item} = this.props;
        const {youtube_video_link, text} = item;

        if(!text) {
            return <section>
                <CentredContentContainer size="huge" extended={true} className={classes.container} >
                    <div className={classes.videoWrapper} dangerouslySetInnerHTML={{__html: youtube_video_link.html}}></div>
                </CentredContentContainer>
            </section>
        }

        return <section>
            <CentredContentContainer extended={true} size="huge" className={classes.containerWithText} >
                <div className={cn(classes.videoContainer)}>
                    <div className={classes.videoWrapper} dangerouslySetInnerHTML={{__html: youtube_video_link.html}}></div>
                </div>
                <RichTextContainer className={cn(classes.textContainer, classes.contentBesideVideo)} content={text} removeBottomMargin={true} />
            </CentredContentContainer>
            <CentredContentContainer size="huge" className={classes.contentUnderVideo} >
                <RichTextContainer className={classes.textContainer} content={text} removeBottomMargin={true} />
            </CentredContentContainer>
        </section>
    }
}

export default injectSheet((theme) => (
{
    container: {
        //display: "flex",
    },
    containerWithText: {
        display: "flex",
        flexDirection: "column",
        [theme.breakpoint("laptop")]: {
            flexDirection: ({item: {text_placement}}) => text_placement === 'Right' ? 'row-reverse' : 'row',
            paddingLeft: ({item: {text_placement}}) => text_placement === 'Right' ? null : 0,
            paddingRight: ({item: {text_placement}}) => text_placement === 'Right' ? 0 : null,
        }
    },
    textContainer: {
        flexBasis: "50%",
        [theme.breakpoint("laptop")]: {
            maxWidth: (theme.content.width - ((theme.content.widthLarge - theme.content.width)/2))/2,
            marginLeft: ({item: {text_placement}}) => text_placement === 'Right' ? null : theme.spacing.normal,
            marginRight: ({item: {text_placement}}) => text_placement === 'Right' ? theme.spacing.normal : null,
        }
    },
    contentUnderVideo: {
        display: 'block',
        [theme.breakpoint("laptop")]: {
            display: 'none'
        }
    },
    contentBesideVideo: {
        display: 'none',
        [theme.breakpoint("laptop")]: {
            display: 'block'
        }
    },
    videoContainer: {
        flexBasis: "50%",
        marginBottom: `${theme.base.lineHeight/2}rem`,
        [theme.breakpoint("laptop")]: {
            margin: 0,
        }
    },
    videoWrapper: {
        position: "relative",
        paddingBottom: "56.25%", // 16:9
        //paddingTop: 25px;
        height: 0,
        "& iframe": {
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
        }
    },
}
))(YouTubeContent)





// WEBPACK FOOTER //
// ./src/components/Article/YouTubeContent.js